import { createSelector } from 'reselect'
import { getCurrentProfileSelect } from '../get-current'
import { PROFILE_KEY } from '../../../../../models/profile/constants'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

export const getDailyCarbsIntakeGoalInGramProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => getValueReduxUtil(profile, PROFILE_KEY.DAILY_CARBOHYDRATE_INTAKE_GOAL_IN_GRAM)
)
